import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getBlogCategories } from '../../data/content';

const BlogCategory = () => {
  const categories = useMemo(() => getBlogCategories(), []);

  return (
    <div className="sidebar__single sidebar__category wow animated fadeInUp" data-wow-delay="0.2s">
      <div className="title">
        <h2>Categories</h2>
      </div>

      <ul className="sidebar__category-list list-unstyled">
        {categories.map(({ category, count }) => (
          <li key={category}>
            <Link to="/events">
              {category.replace(/-/g, ' ')}
              <span>{String(count).padStart(2, '0')}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogCategory;
